/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Row, Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCompanyBookingExtentionInfo } from "redux/actions/admin/BookingExtentionRequestAction";
import ExtentionPendingList from "./admin-pending-extention-request/ExtentionPendingList";
import ExtentionApprovedList from "./admin-extention-approved-request/ExtentionApprovedList";
import ExtentionRejectedList from "./admin-extention-rejected-request/ExtentionRejectedList";
import AllExtentionList from "./admin-all-extention-request/AllExtentionList";
import moment from "moment";

function BookingExtentionDetails({ empId }) {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("0");
  const [empIds, setEmpIds] = useState(empId ? empId : null);
  const notification = useSelector((state) => state.NotificationReducer.result);

  const [searchFormData, setSearchFormData] = useState({
    experience: null,
    skillSet: null,
    fromDate: null,
    toDate: null,
    search: empIds ? empIds : null,
    parentCompany: null,
  });
  const handleClearSearch = () => {
    setSearchFormData({
      experience: null,
      skillSet: null,
      fromDate: null,
      toDate: null,
      search: null,
      parentCompany: null,
    });
  };
  const list = [
    {
      title: "All",
      tabId: "0",
      color: "blue",
    },
    {
      title: "Pending",
      tabId: "1",
      color: "blue",
    },
    {
      title: "Approved",
      tabId: "2",
      color: "green",
    },
    {
      title: "Rejected",
      tabId: "3",
      color: "pink",
    },
  ];

  // HANDLING EMPLOYEE SEARCH
  const handleEmployeeSearchOnChange = (e, v) => {
    setSearchFormData({ ...searchFormData, [e]: v });
  };
  const clearEmpId = () => {
    setEmpIds("");
  };

  const handleClearDate = () => {
    const data = { ...searchFormData, fromDate: null, toDate: null };
    setSearchFormData(data);
    switch (activeTab) {
      case "0":
        getBookingExtentionList("1", "1", "", data);
        break;
      case "1":
        getBookingExtentionList("1", "1", "pending", data);
        break;
      case "2":
        getBookingExtentionList("1", "1", "approved", data);
        break;
      case "3":
        getBookingExtentionList("1", "1", "rejected", data);
        break;

      default:
        break;
    }
  };

  // HANDLE SEARCH FUNCTION
  const handleSearch = (e) => {
    e.preventDefault();
    switch (activeTab) {
      case "0":
        getBookingExtentionList("1", "1", "", searchFormData);
        break;
      case "1":
        getBookingExtentionList("1", "1", "pending", searchFormData);
        break;
      case "2":
        getBookingExtentionList("1", "1", "approved", searchFormData);
        break;
      case "3":
        getBookingExtentionList("1", "1", "rejected", searchFormData);
        break;

      default:
        break;
    }
  };
  const handleSearchOnSelect = (value, name) => {
    let val =
      name === "parentCompany"
        ? { ...searchFormData, parentCompany: value }
        : name === "experience"
        ? { ...searchFormData, experience: name }
        : name === "date"
        ? {
            ...searchFormData,
            fromDate: moment(value.startDate).format("YYYY-MM-DD"),
            toDate: moment(value.endDate).format("YYYY-MM-DD"),
          }
        : { ...searchFormData, search: value };
    setSearchFormData(val);
    switch (activeTab) {
      case "0":
        getBookingExtentionList("1", "1", "", val);
        break;
      case "1":
        getBookingExtentionList("1", "1", "pending", val);
        break;
      case "2":
        getBookingExtentionList("1", "1", "approved", val);
        break;
      case "3":
        getBookingExtentionList("1", "1", "rejected", val);
        break;

      default:
        break;
    }
  };
  // PENDING BOOKING  EXTENTION DATA
  const getBookingExtentionList = (
    createdBy,
    page,
    extentionStatus,
    searchData
  ) => {
    dispatch(
      setCompanyBookingExtentionInfo(
        createdBy,
        page,
        extentionStatus,
        searchData
      )
    );
  };

  //   const bookingExtentionResult = useSelector(
  //     (state) => state.BookingExtentionApprovalRequestReducer.result
  //   );
  //   const bookingExtentionLoader = useSelector(
  //     (state) => state.BookingExtentionApprovalRequestReducer.loader
  //   );

  const toggle = (tab) => {
    setEmpIds(null);
    dispatch({
      type: "NOTIFICATION_RESET",
    });
    if (activeTab !== tab.target.value) {
      switch (tab.target.value) {
        case "0":
          getBookingExtentionList("1", "1", "", null);
          handleClearSearch();
          break;
        case "1":
          getBookingExtentionList("1", "1", "pending", null);
          handleClearSearch();
          break;
        case "2":
          getBookingExtentionList("1", "1", "approved", null);
          handleClearSearch();
          break;
        case "3":
          getBookingExtentionList("1", "1", "rejected", null);
          handleClearSearch();
          break;

        default:
          break;
      }

      setActiveTab(tab.target.value);
    }
  };

  useEffect(() => {
    if (empIds) {
      getBookingExtentionList("1", "1", "", searchFormData);
    }
    if (notification?.empId) {
      setActiveTab("0");
      getBookingExtentionList("1", "1", "", {
        ...searchFormData,
        search: notification?.empId,
      });
    }
  }, [notification]);

  return (
    <>
      <Row>
        {/* <Col md="12" style={{ bottom: "162px" }}>
          <select className="custom-select select-positioned" onChange={(event) => toggle(event)}>
            {list?.map((item, key) => (
              <option key={key} value={item?.tabId}>
                {item?.title}
              </option>
            ))}
          </select>
        </Col> */}
      </Row>
      <Container className="mt-4 main-contentarea container-fluid" fluid>
        <div className="custom-tabs">
          {/* All Booking extension */}

          {activeTab === "0" && (
            <>
              <AllExtentionList
                list={list}
                toggle={toggle}
                handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
                handleSearch={handleSearch}
                searchFormData={searchFormData}
                setSearchFormData={setSearchFormData}
                data={"All Extension Requests"}
                empIds={empIds}
                clearEmpId={clearEmpId}
                handleClearDate={handleClearDate}
                handleSearchOnSelect={handleSearchOnSelect}
              />
            </>
          )}
          {/* Pending extension */}
          {activeTab === "1" && (
            <>
              <ExtentionPendingList
                list={list}
                toggle={toggle}
                handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
                handleSearch={handleSearch}
                searchFormData={searchFormData}
                setSearchFormData={setSearchFormData}
                data={"Pending Extension Requests"}
                handleClearDate={handleClearDate}
                handleSearchOnSelect={handleSearchOnSelect}
              />
            </>
          )}

          {/* APPROVED */}
          {activeTab === "2" && (
            <>
              <ExtentionApprovedList
                list={list}
                toggle={toggle}
                handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
                handleSearch={handleSearch}
                searchFormData={searchFormData}
                setSearchFormData={setSearchFormData}
                data={"Approved Extension Requests"}
                handleClearDate={handleClearDate}
                handleSearchOnSelect={handleSearchOnSelect}
              />
            </>
          )}
          {/* REJECTED */}
          {activeTab === "3" && (
            <>
              <ExtentionRejectedList
                list={list}
                toggle={toggle}
                handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
                handleSearch={handleSearch}
                searchFormData={searchFormData}
                setSearchFormData={setSearchFormData}
                data={["Rejected Extension Requests"]}
                handleClearDate={handleClearDate}
                handleSearchOnSelect={handleSearchOnSelect}
              />
            </>
          )}
        </div>
      </Container>
    </>
  );
}

export default BookingExtentionDetails;
